import { Injectable } from '@angular/core';

import * as moment from 'moment';

@Injectable()
export class DateTimeService {

  constructor() { }

  getMonthName(month: any, short = true): string {
    const shortMonthsNames = ['', 'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez', '13º'];
    const monthsNames = ['', 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro', '13º'];

    if (short) {
      return shortMonthsNames[+month];
    } else {
      return monthsNames[+month];
    }
  }

  getDayOfWeek(date: string): string {
    return moment(date, 'DDMMYYYY').format('dddd');
  }

  getCurrentDay(): string {
    return moment().format('dd');
  }

  getCurrentMonth(): string {
    return moment().format('MM');
  }

  getCurrentYear(): string {
    return moment().format('YYYY');
  }
}
